import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

import { combineReducers, configureStore } from "@reduxjs/toolkit";

import commonReducers from "./reduxToolkitServices/_commonReducers/commonReducers";
import peopleReducers from "./reduxToolkitServices/_commonReducers/peopleReducers";
import fleetReducers from "./reduxToolkitServices/_commonReducers/fleetReducers";
import siteReducers from "./reduxToolkitServices/_commonReducers/siteReducers";
import persistedLocalStorageReducer from "./reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import persistedSessionStorageReducer from "./reduxToolkitServices/_commonReducers/persistedSessionStorageReducer";

const persistLocalStorageConfig = {
  key: "WQwR4bwinKLS1",
  storage: storage,
};

const persistSessionStorageConfig = {
  key: "WQwR4bwinKSS2",
  storage: storageSession,
};

const rootReducer = combineReducers({
  firstReducer: persistReducer(
    persistLocalStorageConfig,
    persistedLocalStorageReducer
  ),
  secondReduces: persistReducer(
    persistSessionStorageConfig,
    persistedSessionStorageReducer
  ),
  commonReducers,
  peopleReducers,
  fleetReducers,
  siteReducers
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
